module.exports = __webpack_public_path__ + "media/images/category/feature/profile/profile-lu-691a55e02b0f1ac6385850b6c57d005f.jpg";